/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import { RaisedButton, Subheader } from 'material-ui'

export default class Section extends React.Component {
  constructor(props) {
    super(props)
    autoBind(this)
  }

  handleChange(event, value) {
    this.props.handleEvaluationChange(this.props.name, value)
  }

  render () {
    return (
      <div
        style={this.props.style}
      >
        {
          this.props.title
            ? <h3 style={{color: '#5d5d5d'}}>{this.props.title}</h3>
            : undefined
        }

        {
          this.props.title &&
          this.props.icons
            ? <div>
              {
                this.props.icons.map((icon, key) => {
                  const isNeutralDisplayed = this.props.buttons.find(button => button.value === null)

                  if (key === 0 && !isNeutralDisplayed) {
                    return
                  }

                  return (
                    <div
                      key={key}
                      style={{
                        ...styles.button,
                        display: 'inline-block'
                      }}
                    >
                      {icon.icon}
                    </div>
                  )
                })
              }
            </div>
            : undefined
        }

        {
          this.props.subHeader
            ? <Subheader style={{lineHeight: '25px'}}>{this.props.subHeader}</Subheader>
            : undefined
        }

        {
          this.props.buttons &&
          this.props.buttons.map((button, key) => {
            return (
              <RaisedButton
                key={key}
                style={styles.button}
                label={button.label || undefined}
                onClick={(event, value) => this.handleChange(event, button.value)}
                primary={this.props.value === button.value ? true : false}
              />
            )
          })
        }
      </div>
    )
  }
}

const styles = {
  button: {
    marginLeft: 5,
    minWidth: 160,
    height: 40
  },
}



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/evaluation/Section.js